import { useMemo } from "react";
import { useIntl } from "react-intl";
import * as Yup from "yup";

const MAX_INT_SIZE = 2147483647;

export const useReceiveValidationSchema = () => {
  const { formatMessage } = useIntl();

  const MAX_INT_SIZE_VALIDATION = Yup.number()
    .integer(
      formatMessage({
        id: "inventory.form.receive.integerInput.error.notAnInt",
        defaultMessage: "Must be a whole number",
      }),
    )
    .min(
      1,
      formatMessage({
        id: "inventory.form.receive.integerInput.error.minimum",
        defaultMessage: "Must be greater than 0",
      }),
    )
    .max(
      MAX_INT_SIZE,
      formatMessage(
        {
          id: "inventory.form.receive.integerInput.error.maximum",
          defaultMessage: "Must be less than {maxSize}",
        },
        { maxSize: MAX_INT_SIZE },
      ),
    );

  const SELECT_ITEM_VALIDATION = Yup.object({
    id: Yup.string().required(),
    name: Yup.string().required(),
  }).required();

  return useMemo(() => {
    return Yup.object({
      supplier: SELECT_ITEM_VALIDATION,
      sku: SELECT_ITEM_VALIDATION,
      quantity: MAX_INT_SIZE_VALIDATION,
      expiryDate: Yup.date().required(),
      quantityPackSize: MAX_INT_SIZE_VALIDATION,
      quantityPacks: MAX_INT_SIZE_VALIDATION,
      locationId: Yup.string().required(),
    });
  }, [MAX_INT_SIZE_VALIDATION, SELECT_ITEM_VALIDATION]);
};

export type FormValues = Yup.Asserts<
  ReturnType<typeof useReceiveValidationSchema>
>;
